import { agentAvatarVisual } from "@app/types/assistant/avatar";
import type { ConversationParticipantsType } from "@app/types/assistant/conversation";
import type { LiveCallMember } from "@memo-air/react";
import { createContext, useContext } from "react";

export type LiveHuddleContextType = {
  openHuddle: (conversationId: string, title: string | null) => Promise<void>;
  inHuddleConversationId: string | null;
};

export const LiveHuddleContext = createContext<LiveHuddleContextType | null>(
  null
);

// Null outside a conversation layout, where there is no chat to call in.
export function useLiveHuddle(): LiveHuddleContextType | null {
  return useContext(LiveHuddleContext);
}

// A conversation's people and agents, as a call's members.
export function callMembersOf(
  participants: ConversationParticipantsType | undefined
): LiveCallMember[] {
  return [
    ...(participants?.users ?? []).map((user) => ({
      id: user.sId,
      name: user.fullName ?? user.username,
      kind: "human" as const,
      pictureUrl: user.pictureUrl,
    })),
    ...(participants?.agents ?? []).map((agent) => ({
      id: agent.configurationId,
      name: agent.name,
      kind: "agent" as const,
      pictureUrl:
        agentAvatarVisual({
          sId: agent.configurationId,
          name: agent.name,
          pictureUrl: agent.pictureUrl,
        }) ?? null,
    })),
  ];
}
